import type React from "react";

import { useClientModules } from "@/hooks/useClientModules";
import NoModules from "@/pages/NoModules";

interface RequireModuleProps {
  module: string;
  children: React.ReactNode;
}

export function RequireModule({ module, children }: RequireModuleProps) {
  const { data: modules, isLoading } = useClientModules();

  if (isLoading) {
    return (
      <div className="min-h-[60vh] w-full flex items-center justify-center">
        Carregando...
      </div>
    );
  }

  const hasModule = (modules ?? []).some((m) => m.module === module);

  if (!hasModule) {
    return (
      <NoModules
        title="Painel não disponível"
        message="Seu plano não inclui este painel. Fale com o administrador da sua conta para liberar o acesso."
        backToRoute="/dashboard"
      />
    );
  }

  return <>{children}</>;
}
